import $http from '../services/AxiosInstance';
import { ITypeContainers } from '../types/typeContainers.type';

interface Params {
  page?: number;
  search?: string;
  deleted?: boolean;
}

class TypesContainersRepository {
  static async getTypesContainers(params: Params = {}) {
    try {
      let url = `/typeContainers`;
      if(params.page){
        url += `?page=${params.page}`;
      }
      if (params.search) {
        url += `&search=${params.search}`;
      }
      if (params.deleted) {
        url += `&deleted=${params.deleted}`;
      }
      const response = await $http.get(url);
      return response.data;
    } catch (errors: any) {
      throw Error;
    }
  }
  static async createTypeContainer(data: ITypeContainers): Promise<ITypeContainers> {
    try {
      const response = await $http.post('/typeContainers', data);

      return response.data;
    } catch (error) {
      throw Error;
    }
  }
  static async updateTypeContainer(data: ITypeContainers): Promise<ITypeContainers> {
    try {
      const response = await $http.patch(`/typeContainers/${data.id}`, data);
      return response.data;
    } catch (error) {
      throw Error;
    }
  }
  static async deleteTypeContainer(id: number): Promise<number> {
    try {
      const response = await $http.delete(`/typeContainers/${id}`);
      return response.status;
    } catch (error) {
      throw Error;
    }
  }
  static async restoreTypeContainer(id: number): Promise<number> {
    try {
      const response = await $http.post(`/typeContainers/restore/${id}`);
      return response.status;
    } catch (error) {
      throw Error;
    }
  }
}

export default TypesContainersRepository;
